﻿export default{
//	baseURL:'http://m-cs.jxjy.ahharc.com/api', //168
	// baseURL:'http://192.168.1.141:8085',   //陈勇
  baseURL:'http://m-hnjx.ahharc.com/api',//线上
//  baseURL:'http://192.168.1.123:8080',   //陈勇
    // baseURL:'http://m-wjjxjy.ahharc.com/api',     
//  baseURL:'http://weixin.ahsjxjy.com/api',         //微信支付测试
//   baseURL:'http://192.168.1.128:9091',
	method:'POST',
	headers: {'Content-Type':'application/x-www-form-urlencoded'},
	transformRequest: [
	    function(data) {
	      	let ret = ''
	      	for (let it in data) {
	        	ret += encodeURIComponent(it) +
	          	'=' +
	          	encodeURIComponent(data[it]) +
	          	'&'
	      	}
	      	return ret
	    }
	],
	timeout: 20000
}



// WEBPACK FOOTER //
// ./src/api/base.js